import React, { useState, useEffect, useRef } from 'react'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import {
   Box,
   Button,
   Card,
   CardHeader,
   Chip,
   Divider,
   Table,
   TableBody,
   TableCell,
   TableHead,
   TableRow,
   TableSortLabel,
   Tooltip,
   Typography
} from '@material-ui/core'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'

import Loader from '../utils/Loader'
// api
import { getPublicAPI } from '../../api'

const LatestOrders = props => {
   let mounted = useRef(true)
   const navigate = useNavigate()

   const [orders, setOrders] = useState([])
   const [loading, setLoading] = useState(true)

   useEffect(() => {
      const prepareOrders = async () => {
         let data = { user: localStorage.user_email, type: localStorage.user_type }

         let ordersData = await getPublicAPI('/get-orders-latest', data)
         if (ordersData?.success) {
            ordersData.data.sort(
               (a, b) => new Date(b.datetime).getTime() - new Date(a.datetime).getTime()
            )

            mounted.current && setOrders(ordersData.data)
            mounted.current && setLoading(false)
         } else mounted.current && setLoading(false)
      }

      prepareOrders()

      return () => (mounted.current = false)
   }, [])

   return (
      <>
         {loading ? (
            <Loader />
         ) : (
            <Card {...props}>
               <CardHeader title='Latest Orders' />
               <Divider />
               {orders?.length > 0 ? (
                  <>
                     <Box sx={{ minWidth: 800 }}>
                        <Table>
                           <TableHead>
                              <TableRow>
                                 <TableCell>Order #</TableCell>
                                 {localStorage.user_type !== 'customer' && (
                                    <TableCell>Customer</TableCell>
                                 )}
                                 <TableCell sortDirection='desc'>
                                    <Tooltip enterDelay={300} title='Sort'>
                                       <TableSortLabel active direction='desc'>
                                          Date
                                       </TableSortLabel>
                                    </Tooltip>
                                 </TableCell>
                                 <TableCell>Amount</TableCell>
                              </TableRow>
                           </TableHead>
                           <TableBody>
                              {orders.slice(0, 7).map(order => (
                                 <TableRow
                                    onClick={() => navigate('/app/order-detail/' + order.oNum)}
                                    hover
                                    key={order._id}
                                 >
                                    <TableCell>{order.oNum}</TableCell>
                                    {localStorage.user_type !== 'customer' && (
                                       <TableCell>{order.user}</TableCell>
                                    )}
                                    <TableCell>
                                       {moment(order.datetime).format('DD/MM/YYYY')}
                                    </TableCell>
                                    <TableCell>
                                       <Chip
                                          color='primary'
                                          label={`$${order.totalAmount?.toFixed(2)}`}
                                          size='small'
                                       />
                                    </TableCell>
                                 </TableRow>
                              ))}
                           </TableBody>
                        </Table>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'flex-end',
                           p: 2
                        }}
                     >
                        <Button
                           onClick={() => navigate('/app/orders')}
                           color='primary'
                           endIcon={<ArrowRightIcon />}
                           size='small'
                           variant='text'
                        >
                           View all
                        </Button>
                     </Box>
                  </>
               ) : (
                  <Typography variant='h2' textAlign='center' sx={{ p: 2 }}>
                     No orders found
                  </Typography>
               )}
            </Card>
         )}
      </>
   )
}

export default LatestOrders
